import { loadStripe } from "@stripe/stripe-js/pure";
import type { Stripe } from "@stripe/stripe-js";

let stripe: Stripe | null = null;

export const getStripe = async (): Promise<Stripe> => {
  if (stripe == null) {
    stripe = await loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY!);
    if (stripe == null) {
      throw new Error("no stripe client");
    }
  }

  return stripe;
};
